import styled from 'styled-components';
import { Box } from 'pcln-design-system';
export const LoadMoreContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "LoadMorestyles__LoadMoreContainer",
  componentId: "sc-ho0lv5-0"
})(["height:455px;border:1px dotted rgba(224,229,234,1);border-radius:16px;width:166px;"]);
export const LinkContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "LoadMorestyles__LinkContainer",
  componentId: "sc-ho0lv5-1"
})(["cursor:pointer;"]);